import styled from "styled-components";
import Icon from "../../components/Icon";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import { Checkbox } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useContext } from "react";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";

interface Props {
  setFilterOpen: any;
  filterOpen: boolean;
  personFilterOpen: boolean;
  setPersonFilterOpen: any;
  codeFilterOpen: boolean;
  setCodeFilterOpen: any;
  filterCompetencyChecked: boolean;
  setFilterCompetencyChecked: any;
  isTypeFiltered: boolean;
  isCodeFiltered: boolean;
  isPersonFiltered: boolean;
  tempFilterCode: string;
  tempFilterPerson: string;
  programOptions?: any[];
  selectedProgram?: any;
  setSelectedProgram: any;
}

export const FilterBar = (props: Props) => {
  const {
    setFilterOpen,
    setCodeFilterOpen,
    setPersonFilterOpen,
    personFilterOpen,
    filterOpen,
    filterCompetencyChecked,
    setFilterCompetencyChecked,
    isTypeFiltered,
    isCodeFiltered,
    isPersonFiltered,
    codeFilterOpen,
    tempFilterCode,
    tempFilterPerson,
    programOptions,
    selectedProgram,
    setSelectedProgram,
  } = props;

  // console.log("selected program",selectedProgram)
  const universityContext = useContext(UniversityContext);

  const StyledFilterBar = styled.div`
    max-width: fit-content;
    border-radius: 6px;
    // padding: px;
    // border: 1px solid white;
    background: #ffffff0a;
    align-items: center;
    display: flex;
    // margin-bottom: 10px;
    // gap: 20px;
    box-shadow: 0px 1px 1px black;
  `;
  const StyleElements = styled.span`
    // border-right: 1px solid #363636;
    align-items: center;
    padding: 3px 15px;
    display: flex;
    // font-size: 12px;
    cursor: pointer;
    color: #ffffff;
    &:hover {
      color: #ffd700;
      // text-shadow: 0px 4px 7px black; /* Adjust values as needed */
    }
  `;
  const userContext = useContext(UserContext);

  return (
    <StyledFilterBar>
      <StyleElements
        style={{
          borderRight: "1px solid #363636",
          cursor: "default",
          fontWeight: "bold",
          color: "white",
        }}
      >
        <Icon color="#ffffff4d" size={2.8} name="filter" mr={1} />
        Filter By
      </StyleElements>
      <StyleElements
        onClick={() => {
          setFilterOpen(!filterOpen);
        }}
        style={{
          color: isTypeFiltered ? "#FFD700" : "none",
          // fontWeight: isTypeFiltered ? "bold" : "normal",
          boxShadow: isTypeFiltered ? "0 2 4px black" : "none",
        }}
      >
        <Icon
          color={isTypeFiltered ? "#FFD700" : "#ffffff4d"}
          name="apps"
          mr={0.5}
        />
        Event Types
      </StyleElements>
      <StyleElements
        onClick={() => {
          setCodeFilterOpen(!codeFilterOpen);
        }}
        style={{
          color: isCodeFiltered ? "#FFD700" : "none",
          // fontWeight: isCodeFiltered ? "bold" : "normal",
          boxShadow: isCodeFiltered ? "0 2 4px black" : "none",
        }}
      >
        <Icon
          color={isCodeFiltered ? "#FFD700" : "#ffffff4d"}
          name="google-hangouts"
          mr={0.5}
        />
        Competency Code{" "}
        {isCodeFiltered && (
          <span
            style={{
              fontWeight: "normal",
              fontSize: 12,
              color: "#ffffff",
              marginLeft: 2,
            }}
          >
            ({tempFilterCode})
          </span>
        )}
      </StyleElements>
      <StyleElements
        onClick={() => {
          setPersonFilterOpen(!filterOpen);
        }}
        style={{
          color: isPersonFiltered ? "#FFD700" : "none",
          // fontWeight: isPersonFiltered ? "bold" : "normal",
          boxShadow: isPersonFiltered ? "0 2 4px black" : "none",
        }}
      >
        <Icon
          color={isPersonFiltered ? "#FFD700" : "#ffffff4d"}
          name="user-check"
          mr={0.5}
        />
        Responsible Person
        {isPersonFiltered && (
          <span
            style={{ fontWeight: "normal", color: "#ffffff", marginLeft: 2 }}
          >
            ({tempFilterPerson})
          </span>
        )}
      </StyleElements>
      <StyleElements
        // onClick={() => {
        //   setPersonFilterOpen(!filterOpen);
        // }}
        style={{
          color: isPersonFiltered ? "#FFD700" : "none",
          // fontWeight: isPersonFiltered ? "bold" : "normal",
          boxShadow: isPersonFiltered ? "0 2 4px black" : "none",
        }}
      >
        <Icon
          color={isPersonFiltered ? "#FFD700" : "#ffffff4d"}
          name="clipboard"
          mr={0.5}
        />
        {/* Program */}
        {/* {isPersonFiltered && (
          <span
            style={{ fontWeight: "normal", color: "#ffffff", marginLeft: 2 }}
          >
            ({tempFilterPerson})
          </span>
        )} */}
        <MinimalSelect
          setClass={"custom-container"}
          // setClass={"rs-container"}
          required
          placeholder="Program"
          options={[
            { label: "ALL Programs", value: "ALL" },
            ...(universityContext.programs || []),
          ]}
          // value={universityContext.programs?.find(
          //   (v: any) =>
          //     v.program_abbrev ===
          //     universityContext.selectedProgram?.program_abbrev
          // )}
          value={(() => {
            const opts = [
              { label: "ALL Programs", value: "ALL" },
              ...(universityContext.programs || []),
            ];
            // if no program selected => return ALL
            if (!universityContext.selectedProgram) return opts[0];
            // try to find matching program by abbrev
            return (
              opts.find(
                (v: any) =>
                  v.short_name ===
                  universityContext.selectedProgram?.short_name
              ) || opts[0]
            );
          })()}
          onChange={(newValue: any) => {
            universityContext.setProgram(newValue);
          }}
        />
      </StyleElements>
      <StyleElements
        style={{
          color: filterCompetencyChecked ? "#FFD700" : "none",
          boxShadow: filterCompetencyChecked ? "0 2 4px black" : "none",
        }}
        onClick={() => setFilterCompetencyChecked(!filterCompetencyChecked)} // Toggle the checkbox when clicking the element
      >
        <Checkbox
          checked={filterCompetencyChecked}
          onChange={(e) => {
            // Prevent the click event from propagating to the StyleElements
            e.stopPropagation();
            setFilterCompetencyChecked(e.target.checked);
          }}
          sx={{
            color: "#ffffff4d",
            "&.Mui-checked": {
              color: "#FFD700",
            },
          }}
        />
        {userContext.user.role === 1 ? "My Competencies" : "My Events"}
      </StyleElements>
    </StyledFilterBar>
  );
};
